import { Injectable } from '@angular/core';
import emailjs, { EmailJSResponseStatus } from '@emailjs/browser';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private readonly EMAILJS_SERVICE_ID = environment.emailjs.serviceId; 
  private readonly EMAILJS_TEMPLATE_ID = environment.emailjs.templateId; 
  private readonly EMAILJS_PUBLIC_KEY = environment.emailjs.publicKey; 

  constructor() { }

  sendEmail(toEmail: string, message: string): Promise<EmailJSResponseStatus> {
    const emailParams = {
      to_email: toEmail,
      message: message
    };

    return emailjs.send(
      this.EMAILJS_SERVICE_ID, 
      this.EMAILJS_TEMPLATE_ID, 
      emailParams, 
      this.EMAILJS_PUBLIC_KEY
    );
  }
}
